import { render, staticRenderFns } from "./RatingAttribute.vue?vue&type=template&id=4f020e5d&scoped=true"
import script from "./RatingAttribute.vue?vue&type=script&lang=js"
export * from "./RatingAttribute.vue?vue&type=script&lang=js"
import style0 from "./RatingAttribute.vue?vue&type=style&index=0&id=4f020e5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f020e5d",
  null
  
)

export default component.exports